import React from 'react';
import {Link, pxToEm} from 'src/components/globalStyles';
import HexagonIconImage from 'src/components/hexagonIconImage';
import {PlaybackFeature} from 'src/data/playbackFeaturesData';
import ArrowRightSvg from 'src/media/arrow_right.svg';
import styled from 'styled-components';

//#region Styled Components

const StyledWrapper = styled.div`
  display: flex;
  align-items: flex-start;
`;

const StyledTextWrapperDiv = styled.div`
  margin-left: ${pxToEm(39)}em;
`;

const StyledH3 = styled.h3`
  font-size: ${pxToEm(21)}em;
  margin: 0;
`;

const descriptionFontSizePx = 16;
const StyledDescriptionP = styled.p`
  font-size: ${pxToEm(descriptionFontSizePx)}em;
  line-height: 2;
  text-align: justify;
  margin: ${pxToEm(19) / pxToEm(descriptionFontSizePx)}em 0;
`;

const StyledLinkWrapperDiv = styled.div`
  display: flex;
  align-items: center;
`;

const StyledLinkSpan = styled.span`
  color: white;
  margin-right: ${pxToEm(15)}em;
`;

const StyledLinkImg = styled.img`
  background-color: white;
  border-radius: 50%;
  padding: ${pxToEm(4)}em;
`;

//#endregion

interface Props {
  feature: PlaybackFeature;
  className?: string;
  path?: string;
}

const Feature: React.FunctionComponent<Props> = ({feature, className, path}) => {
  const renderLinkToFeature = (featurePath: string) => {
    if (featurePath === null) {
      return null;
    }

    return (
      <Link to={featurePath}>
        <StyledLinkWrapperDiv>
          <StyledLinkSpan>Learn more</StyledLinkSpan>
          <StyledLinkImg src={ArrowRightSvg} alt="arrow right" />
        </StyledLinkWrapperDiv>
      </Link>
    );
  };

  return (
    <StyledWrapper className={className}>
      <HexagonIconImage iconSrc={feature.iconPath} />
      <StyledTextWrapperDiv>
        <StyledH3>{feature.name}</StyledH3>
        <StyledDescriptionP>{feature.description}</StyledDescriptionP>

        {renderLinkToFeature(path)}
      </StyledTextWrapperDiv>
    </StyledWrapper>
  );
};

export default Feature;
